<script>
  import { getNavState, getAccessibilityRedesignRenderState } from '../../../../../../../../js/stores';
  import { trackLinkClick } from '../../../../../../../../js/trackLinkClick';

  // Props
  export let id;
  export let title;
  export let url;
  export let description;

  // Constants
  const navStateStore = getNavState();
  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();

  // On mouseover, close any open subcategories.
  function onMouseOver() {
    $navStateStore = { ...$navStateStore, subcategory: null };
  }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<a
  {id}
  class="CategoryLink"
  class:focus-highlight={!$accessibilityRedesignRenderStore}
  class:focus-accessibility-redesign={$accessibilityRedesignRenderStore}
  href={url}
  on:mouseover={onMouseOver}
  use:trackLinkClick={{ id, title, url }}
>
  <span
    class:title={!$accessibilityRedesignRenderStore}
    class:title-accessibility-redesign={$accessibilityRedesignRenderStore}
  >
    {title}
  </span>
  {#if description}<span class="description">{description}</span>{/if}
</a>

<style>@charset "UTF-8";
.CategoryLink {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  position: relative;
  min-height: 0;
  max-height: none;
  max-width: 278px;
  width: 100%;
  margin: 0;
  padding: 10px 20px;
  border-radius: 0;
  border: 0;
  outline: 0;
  color: var(--color-text, #1a1a1a);
  background-color: transparent;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
}

.title {
  display: block;
  position: relative;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
}

.title-accessibility-redesign {
  display: inline;
  padding-bottom: 3px;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
}

.description {
  display: block;
  position: relative;
  width: 238px;
  font-size: 12px;
  line-height: 22px;
}

.focus-highlight {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.focus-highlight::-moz-focus-inner {
  border: 0;
}
.focus-highlight:focus {
  outline: none;
}
.focus-highlight::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.focus-highlight:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .focus-highlight:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.focus-highlight > * {
  position: relative;
}

.focus-accessibility-redesign:focus-visible:not(:active) :global(span) {
  border-radius: 4px;
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
.focus-accessibility-redesign span {
  background-image: linear-gradient(var(--color-text), var(--color-text));
  background-size: 0% 1.5px;
  background-repeat: no-repeat;
  background-position: calc(100% - 0px) calc(100% - 1.5px);
  transition: background-size 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
@media (hover: hover) {
  .focus-accessibility-redesign:hover span {
    background-position: calc(0% + 0px) calc(100% - 1.5px);
    background-size: calc(100% - 0px) 1.5px;
  }
}</style>
